import { Chip, type ChipProps } from "@mui/material";
import type { FC } from "react";

import { FramerTooltip } from "../../../common";

interface ITechnicalNameChipProps {
  label: string;
  technicalName?: string;
  /** Tooltip when this selected id is highlighted (e.g. from the ride's price rate). */
  highlightTooltip?: string;
  isHighlighted?: boolean;
  /** What Autocomplete's `getItemProps` returns for this chip, without its `key`. */
  chipProps: Omit<ChipProps, "label">;
}

/** A selected-value chip that shows the option's code name on hover. */
export const TechnicalNameChip: FC<ITechnicalNameChipProps> = ({
  label,
  technicalName,
  highlightTooltip,
  isHighlighted,
  chipProps,
}) => {
  const tooltip = highlightTooltip ?? technicalName;
  const chip = (
    <Chip
      label={label}
      {...chipProps}
      color={isHighlighted ? "primary" : chipProps.color}
      variant={isHighlighted ? "outlined" : chipProps.variant}
      {...(isHighlighted
        ? { "data-e2e": "multiselect-bound-chip-highlighted" }
        : {})}
    />
  );

  if (!tooltip) {
    return chip;
  }

  return <FramerTooltip content={tooltip}>{chip}</FramerTooltip>;
};
